import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

/**
 * Yeniden kullanılabilir EmptyState komponenti.
 *
 * Props:
 *   icon      — React node (Lucide ikonu önerilir)
 *   title     — Başlık metni
 *   desc      — Açıklama (opsiyonel)
 *   action    — { label, onClick, variant? } — CTA butonu (opsiyonel)
 *   secondary — { label, onClick } — İkincil aksiyon (opsiyonel)
 *   className — Wrapper sınıfı
 *   size      — "sm" | "md" (default "md")
 */
export default function EmptyState({
  icon,
  title,
  desc,
  action,
  secondary,
  className,
  size = "md",
}) {
  const isSmall = size === "sm";

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center",
        isSmall ? "py-10 px-4" : "py-16 px-6",
        className
      )}
    >
      {icon && (
        <div
          className={cn(
            "rounded-2xl bg-muted flex items-center justify-center mb-4 text-muted-foreground",
            isSmall ? "h-12 w-12" : "h-16 w-16"
          )}
        >
          <span className={isSmall ? "[&>svg]:h-6 [&>svg]:w-6" : "[&>svg]:h-8 [&>svg]:w-8"}>
            {icon}
          </span>
        </div>
      )}

      <h3
        className={cn(
          "font-semibold text-foreground",
          isSmall ? "text-sm" : "text-base"
        )}
      >
        {title}
      </h3>

      {desc && (
        <p
          className={cn(
            "text-muted-foreground mt-1.5 max-w-sm",
            isSmall ? "text-xs" : "text-sm"
          )}
        >
          {desc}
        </p>
      )}

      {(action || secondary) && (
        <div className="flex items-center gap-3 mt-5">
          {secondary && (
            <Button
              variant="outline"
              size={isSmall ? "sm" : "default"}
              onClick={secondary.onClick}
            >
              {secondary.label}
            </Button>
          )}
          {action && (
            <Button
              variant={action.variant || "default"}
              size={isSmall ? "sm" : "default"}
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
